import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import StorageHelper from "../../../helpers/StorageHelper";
import { setUserEmail } from "../../../configurations/redux-configurations/actions/userAction";
import AuthHelper from "../../../helpers/AuthHelper";
import FarmerSessionError from "./FarmerSessionError";
import LoadingOverlay from "../../common/LoadingOverlay";
import { Navigate } from "react-router-dom";

function FarmerSession() {
  const dispatch = useDispatch();
  const [redirect, setRedirect] = useState(false);
  const [redirectError, setRedirectError] = useState(false);

  useEffect(() => {
    (async function () {
      const urlParams = new URLSearchParams(window.location.search);
      const reqId = urlParams.get("token");
      try {
        const response = await AuthHelper.SignInWithToken(reqId);
        const farmerSessionValue = response.data.data;
        const username = farmerSessionValue.username;
        dispatch(setUserEmail(username));
        StorageHelper.setItem(`username`, username);
        StorageHelper.setItem(
          `${username}.idToken`,
          farmerSessionValue.IdToken
        );
        StorageHelper.setItem(
          `${username}.accessToken`,
          farmerSessionValue.AccessToken
        );
        StorageHelper.setItem(
          `${username}.refreshToken`,
          farmerSessionValue.RefreshToken
        );
        setRedirectError(false);
        setRedirect(true);
      } catch (error) {
        setRedirectError(true);
        setRedirect(true);
      }
    })();
  }, []);

  return (
    <div>
      {redirect ? (
        redirectError ? (
          <FarmerSessionError />
        ) : (
          <Navigate to="/dashboard" />
        )
      ) : (
        <LoadingOverlay
          showSpinner={true}
          active={!redirect}
          text={"Loading Farmer Session..."}
        />
      )}
    </div>
  );
}

export default FarmerSession;
